module.exports = __webpack_public_path__ + "img/mobile_bg_0.7fe3e2fd.png";